module.exports = __webpack_public_path__ + "static/media/qrcode.2c08793c.png";